export const Arrow = (props: { adaptive?: boolean }) => {
    const classNames = [
        'w-6 h-6 shrink-0',
        props.adaptive && 'rotate-90 sm:rotate-0',
    ].filter(Boolean).join(' ');

    return <div className={classNames}>
        <svg
            className="stroke-blue-200"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
            stroke="currentColor"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/>
        </svg>
    </div>;
}
